/** Lightweight DOM confetti — no external deps. */
export function burstConfetti(durationMs = 2200): void {
  if (typeof document === 'undefined') return;

  const colors = ['#1B4F8A', '#E8793A', '#22c55e', '#f59e0b', '#ef4444', '#a855f7'];
  const container = document.createElement('div');
  container.setAttribute('aria-hidden', 'true');
  container.style.cssText =
    'pointer-events:none;position:fixed;inset:0;z-index:9999;overflow:hidden';
  document.body.appendChild(container);

  const pieces: HTMLDivElement[] = [];
  for (let i = 0; i < 48; i++) {
    const piece = document.createElement('div');
    const size = 6 + Math.random() * 6;
    piece.style.cssText = [
      'position:absolute',
      'top:-12px',
      `left:${Math.random() * 100}%`,
      `width:${size}px`,
      `height:${size * (0.6 + Math.random() * 0.8)}px`,
      `background:${colors[i % colors.length]}`,
      'border-radius:2px',
      'opacity:0.95',
      `transform:rotate(${Math.random() * 360}deg)`,
      `animation:fixflow-confetti-fall ${1.2 + Math.random() * 1.4}s ease-in forwards`,
      `animation-delay:${Math.random() * 0.35}s`,
    ].join(';');
    pieces.push(piece);
    container.appendChild(piece);
  }

  if (!document.getElementById('fixflow-confetti-keyframes')) {
    const style = document.createElement('style');
    style.id = 'fixflow-confetti-keyframes';
    style.textContent = `
      @keyframes fixflow-confetti-fall {
        0% { transform: translateY(0) rotate(0deg); opacity: 1; }
        100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
      }
    `;
    document.head.appendChild(style);
  }

  window.setTimeout(() => {
    container.remove();
    for (const p of pieces) p.remove();
  }, durationMs);
}
